module.exports = __webpack_public_path__ + "static/img/n11-logo.4209ad6b.svg";